import { Empty } from 'antd';
import search_none from "./image/empty.svg"
import "./index.scss"


export default function LabelNone(props) {
    return (
        <>
            {props.search && (
                <Empty
                    description={props.tips||"暂无数据"}
                    image={search_none}
                    className='rsm_common_none rsm_absolute_center rsm_search_none'
                />
            )}
            {!props.search && (
                <Empty
                    description={props.tips||"暂无数据"}
                    className='rsm_common_none rsm_absolute_center'
                />
            )}
        </>

    )
}